module.exports = __webpack_public_path__ + "img/gucci.d0cbed6f.jpg";